import { css } from "emotion";
import styleConfig from "./styleConfig";

const { colors, padding, boxShadow, fontSize, transition } = styleConfig;

export const buttonStyle = css`
  display: inline-flex;
  align-items: center;
  border: 0;
  text-transform: uppercase;
  font-weight: bold;
  font-size: ${fontSize.xs};
  line-height: 2rem;
  border-radius: 9999px;
  color: ${colors.white};
  margin: 0 auto;
  padding: ${padding[2]} ${padding[6]};
  background: linear-gradient(71.34deg, ${colors.primary[400]} 0%, ${colors.primary[200]} 100%);
  background-size: calc(100% + 30px) 30px;
  background-position: -30px 0;
  transition: ${transition.default};
  outline: none;
  box-shadow: ${boxShadow.sm};
  &:hover {
    transform: translateY(-2px);
    background-position: 0 0;
    box-shadow: ${boxShadow.xl};
    cursor: pointer;
  }
  &:disabled {
    transform: translateY(0);
    background: ${colors.gray[400]};
    box-shadow: initial;
    cursor: not-allowed;
  }
`;
